import { render, staticRenderFns } from "./distincted-list.vue?vue&type=template&id=46ede31e&"
import script from "./distincted-list.vue?vue&type=script&lang=js&"
export * from "./distincted-list.vue?vue&type=script&lang=js&"
import style0 from "./distincted-list.vue?vue&type=style&index=0&id=46ede31e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports